import { GatorProtectActionTypes } from './gatorProtect.types';

const gatorProtectLoading = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_LOADING, payload });

const listPlansRequest = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_REQUEST });
const listPlansSuccess = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_SUCCESS });
const listPlansFailure = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_FAILURE });
const listPlansSet = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_LIST_PLANS_SET, payload });

const buyRequest = ({ id, domain, redirectToInvoice }) => ({ type: GatorProtectActionTypes.GATOR_PROTECT_BUY_PRODUCT, payload: { id, domain, redirectToInvoice } });

const getPlanDetailsRequest = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_REQUEST, payload });
const getPlanDetailsSuccess = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_SUCCESS });
const getPlanDetailsFailure = () => ({ type: GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_FAILURE });
const getPlanDetailsSet = payload => ({ type: GatorProtectActionTypes.GATOR_PROTECT_GET_PLAN_DETAILS_SET, payload });

const actions = {
  loading: gatorProtectLoading,
  buy: {
    request: buyRequest,
  },
  plans: {
    request: listPlansRequest,
    success: listPlansSuccess,
    failure: listPlansFailure,
    set: listPlansSet,
  },
  planDetails: {
    request: getPlanDetailsRequest,
    success: getPlanDetailsSuccess,
    failure: getPlanDetailsFailure,
    set: getPlanDetailsSet,
  },
};

export default actions;
